import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App.js";
import reportWebVitals from "./reportWebVitals";
import { HashRouter } from "react-router-dom";
import { RecoilRoot } from "recoil";
ReactDOM.render(
  <RecoilRoot>
    <HashRouter>
      <App />
    </HashRouter>
  </RecoilRoot>,
  document.getElementById("root")
);

reportWebVitals();
